import { isTauriMode } from "./environmentDetector";
import { readCustomerPin } from "./customerScreenChannel";

const LABEL = "customer";
const BROWSER_NAME = "nuage-customer-screen";
let browserWindow = null;

const customerUrl = () => {
  const url = new URL(window.location.href);
  url.hash = "#/customer";
  return url.href;
};

const openBrowserWindow = () => {
  browserWindow = window.open(customerUrl(), BROWSER_NAME, "width=1024,height=768");
  if (browserWindow) browserWindow.focus();
};

const placeOnSecondMonitor = async () => {
  try {
    const { availableMonitors, currentMonitor } = await import("@tauri-apps/api/window");
    const monitors = await availableMonitors();
    const current = await currentMonitor();
    const other = monitors.find((monitor) => {
      if (!current?.position || !monitor?.position) return false;
      return monitor.position.x !== current.position.x || monitor.position.y !== current.position.y;
    });
    if (!other?.position?.toLogical) return null;
    const logical = other.position.toLogical(other.scaleFactor || 1);
    return { x: logical.x, y: logical.y };
  } catch {
    return null;
  }
};

export const openCustomerWindow = async () => {
  if (!isTauriMode()) {
    openBrowserWindow();
    return;
  }
  const { WebviewWindow } = await import("@tauri-apps/api/webviewWindow");
  const existing = await WebviewWindow.getByLabel(LABEL);
  if (existing) {
    await existing.show();
    await existing.unminimize();
    await existing.setFocus();
    return;
  }
  const pin = readCustomerPin();
  const second = pin?.pinned ? null : await placeOnSecondMonitor();
  const options = {
    url: customerUrl(),
    title: "Customer screen",
    width: 1024,
    height: 768,
    resizable: true,
    decorations: false,
    center: !pin?.pinned && !second,
    alwaysOnTop: !!pin?.pinned,
    focus: true,
  };
  if (second) {
    options.x = second.x;
    options.y = second.y;
  }
  const created = new WebviewWindow(LABEL, options);
  created.once("tauri://error", (event) => {
    console.warn("Customer screen window was not created", event);
  });
};

export const closeCustomerWindow = async () => {
  if (!isTauriMode()) {
    if (browserWindow && !browserWindow.closed) browserWindow.close();
    browserWindow = null;
    return;
  }
  try {
    const { WebviewWindow } = await import("@tauri-apps/api/webviewWindow");
    const existing = await WebviewWindow.getByLabel(LABEL);
    if (existing) await existing.close();
  } catch (error) {
    console.warn("Customer screen window was not closed", error);
  }
};
